var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var removeUndefinedValues = function (obj) {
    var newObj = __assign({}, obj);
    Object.keys(newObj).forEach(function (key) {
        if (newObj[key] === undefined) {
            delete newObj[key];
        }
    });
    return newObj;
};
